<template>
    <div>
        <a-table
            size="middle"
            :key="this.loading.key"
            :columns="columns"
            :rowKey="record => record.id ? record.id : Math.random()"
            :dataSource="list"
            :pagination="false"
            :loading="this.loading.effects[selectType]"
        >
            <template slot="operation" slot-scope="text,record">
                <!-- <a-popconfirm title="确认删除?" @confirm="() => onDelete(record)">
                    <a :disabled="that.loading.effects[deleteType]" href="javascript:;">删除</a>
                </a-popconfirm>-->
                <a
                    :disabled="that.loading.effects[addType]"
                    @click="e => addserver(record, e)"
                    href="javascript:;"
                >添加服务器</a>
            </template>
        </a-table>
        <v-pageinfo v-if="pagination.total > 0" :pagination="pagination"></v-pageinfo>
        <a-modal
            :visible="visible"
            title="添加服务器"
            @cancel="closeModal"
            @ok="handleSubmit"
            :confirmLoading="that.loading.effects[addType]"
        >
            <a-form @submit="handleSubmit" layout="inline" :form="form">
                <a-form-item label="系统名称">
                    <a-input
                        :disabled="true"
                        style="width:300px"
                        v-decorator="[
                                'systemname',
                                {
                                    initialValue: that.record.systemname,
                                    rules: [{ required: true, message: '请输入系统名称' }]
                                }
                            ]"
                        placeholder="请输入系统名称"
                    />
                </a-form-item>
                <div class="mb20"></div>
                <a-form-item label="服务器IP">
                    <a-input
                        style="width:300px"
                        v-decorator="[
                                'serverip',
                                {
                                    initialValue: undefined,
                                    rules: [{ required: true, message: '请输入服务器IP' }]
                                }
                            ]"
                        placeholder="请输入服务器IP"
                    />
                </a-form-item>
            </a-form>
        </a-modal>

        <!-- 复制操作 -->
        <a-modal
            :visible="visiblecopy"
            title="复制服务器配置"
            @cancel="closeModal"
            @ok="handleSubmitCopy"
            :confirmLoading="that.loading.effects[copyType]"
        >
            <a-form @submit="handleSubmitCopy" layout="inline" :form="form">
                <a-form-item label="新服务器IP">
                    <a-input
                        style="width:300px"
                        v-decorator="[
                                'newserverip',
                                {
                                    //initialValue: that.record.newserverip,
                                    rules: [{ required: true, message: '请输入新服务器IP' }]
                                }
                            ]"
                        placeholder="请输入新服务器IP"
                    />
                </a-form-item>
            </a-form>
        </a-modal>
    </div>
</template>

<script>
import { mapState } from "vuex";

const storeNamespace = "rc_io";

// const columns = []

export default {
    data() {
        return {
            that: this,
            record: {},
            storeNamespace,
            selectType: `${storeNamespace}/syslist`,
            addType: `${storeNamespace}/addserver`,
            editType: `${storeNamespace}/editflag`,
            deleteType: `${storeNamespace}/delserver`,
            copyType: `${storeNamespace}/copyserver`,
            refreshType: `${storeNamespace}/refreshserver`,
            form: this.$form.createForm(this),
            visible: false,
            visiblecopy: false,
            columns: [
                {
                    title: "序号",
                    width: 80,
                    align: "center",
                    customRender: (text, record, index) => ++index
                },
                {
                    title: "系统名称",
                    dataIndex: "systemname"
                },
                {
                    title: "服务器IP",
                    dataIndex: "servers",
                    customRender: text => {
                        // let arr = text.split(",");
                        if (text.length === 0) return "";
                        // console.log(text,"text");return;
                        return text.map(item => {
                            return (
                                <div style={{ color: "#ccc" }}>
                                    <span
                                        style={{
                                            width: "110px",
                                            display: "inline-block",
                                            color: "#333"
                                        }}
                                    >
                                        {item.serverip}
                                    </span>
                                    <router-link
                                        to={{
                                            path: "config",
                                            query: {
                                                systemname: item.systemname,
                                                serverip: item.serverip
                                            }
                                        }}
                                        class="ml7 mr5"
                                    >
                                        配置
                                    </router-link>
                                    |
                                    <a-popconfirm
                                        title="确认删除?"
                                        onConfirm={e => this.onDelete(item, e)}
                                        disabled={
                                            this.loading.effects[
                                                this.deleteType
                                            ]
                                        }
                                    >
                                        <a class="ml7 mr5">删除</a>
                                    </a-popconfirm>
                                    |
                                    <a
                                        onClick={e => this.copy(item, e)}
                                        disabled={
                                            this.loading.effects[this.copyType]
                                        }
                                        class="ml7 mr5"
                                    >
                                        复制
                                    </a>
                                    |
                                    <a
                                        onClick={e => this.refresh(item, e)}
                                        disabled={
                                            this.loading.effects[
                                                this.refreshType
                                            ]
                                        }
                                        class="ml7 mr5"
                                    >
                                        刷新
                                    </a>
                                    |
                                    <a
                                        onClick={e =>
                                            this.editflag(item, e, "true")
                                        }
                                        disabled={
                                            this.loading.effects[
                                                this.refreshType
                                            ]
                                        }
                                        class="ml7 mr5"
                                    >
                                        开启
                                    </a>
                                    |
                                    <a
                                        onClick={e =>
                                            this.editflag(item, e, "false")
                                        }
                                        disabled={
                                            this.loading.effects[
                                                this.refreshType
                                            ]
                                        }
                                        class="ml7 mr5"
                                    >
                                        禁用
                                    </a>
                                    |
                                    <span class="ml7 mr5">
                                        当前状态为{" "}
                                        {item.flag == "true" ? (
                                            <font style={{ color: "green" }}>
                                                开启
                                            </font>
                                        ) : (
                                            <font style={{ color: "red" }}>
                                                禁用
                                            </font>
                                        )}
                                    </span>
                                </div>
                            );
                        });
                    }
                },
                {
                    title: "操作",
                    width: 146,
                    scopedSlots: { customRender: "operation" }
                }
            ],
            action: ""
        };
    },
    methods: {
        showModal() {
            this.visible = true;
        },
        closeModal() {
            this.visible = false;
            this.visiblecopy = false;
        },
        handleSubmit(e) {
            e.preventDefault();
            this.form.validateFields((err, values) => {
                if (err) return;
                this.$store
                    .dispatch({
                        type: this.addType,
                        params: values
                    })
                    .then(() => {
                        let {query} = this.$route;
                        this.$router.push({
                            path: "list",
                            query: {
                                ...query,
                                _t: new Date().getTime()
                            }
                        });
                    });
            });
        },
        //删除
        onDelete(record, e) {
            e.preventDefault();
            this.$store.dispatch({
                type: this.deleteType,
                params: record
            });
        },
        addserver(record, e) {
            e.preventDefault();
            this.record = record;
            this.showModal();
            /* this.$store.dispatch({
                type: this.addType,
                params: record
            }); */
        },
        handleSubmitCopy(e) {
            e.preventDefault();
            this.form.validateFields((err, values) => {
                if (err) return;

                this.$store
                    .dispatch({
                        type: this.copyType,
                        params: {
                            ...this.record,
                            newserverip: values.newserverip
                        }
                    })
                    .then(() => {
                        this.visiblecopy = false;
                    });
            });
        },
        //复制服务器配置
        copy(record, e) {
            e.preventDefault();
            this.visiblecopy = true;
            this.record = record;
        },
        //刷新服务器配置
        refresh(record, e) {
            e.preventDefault();
            this.$store.dispatch({
                type: this.refreshType,
                params: record
            });
        },
        //编辑状态
        editflag(record, e, flag = "true") {
            e.preventDefault();
            this.$store
                .dispatch({
                    type: this.editType,
                    params: {
                        ...record,
                        // flag: record.flag === "true" ? "false" : "true"
                        flag
                    }
                })
                .then(() => {
                    let {query} = this.$route;
                    this.$router.push({
                        path: "list",
                        query: {
                            ...query,
                            _t: new Date().getTime()
                        }
                    });
                });
        }
    },
    computed: {
        ...mapState(storeNamespace, {
            list: state => state.list,
            pagination: state => {
                return state.pagination;
            }
        })
    },
    beforeMount() {},
    mounted() {
        this.$store.dispatch({
            type: this.selectType
        });
    }
};
</script>
<style lang="less" scoped>
</style>
